import { render, staticRenderFns } from "./SelectBoxV4.vue?vue&type=template&id=75c3463a&scoped=true&"
import script from "./SelectBoxV4.vue?vue&type=script&lang=ts&"
export * from "./SelectBoxV4.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBoxV4.vue?vue&type=style&index=0&id=75c3463a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c3463a",
  null
  
)

export default component.exports